module.exports = __webpack_public_path__ + "static/sf-ui-medium-252c67cc6dc27215c26ca02b82c80e83.eot";